import { render, staticRenderFns } from "./addCar.vue?vue&type=template&id=1347b800&scoped=true&"
import script from "./addCar.vue?vue&type=script&lang=js&"
export * from "./addCar.vue?vue&type=script&lang=js&"
import style0 from "./addCar.vue?vue&type=style&index=0&id=1347b800&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1347b800",
  null
  
)

export default component.exports